import React, { useCallback, useEffect, useRef, useState } from 'react';

import * as ST from './styled';

export interface IKebabItem {
    value: string,
    label: string,
}

export interface KebabMenuProps {
    menuItems: IKebabItem[],
    onSelectMenu: (item: IKebabItem) => void,
    onClickMenu?: (menuStatus: boolean) => void,
    className?: string,
}

/**
 * Выпадающее меню с троеточием
 * @param menuItems пункты меню
 * @param onSelectMenu при выборе пункта меню
 * @param onClickMenu при раскрытии меню
 * @param className
 */
export const KebabMenu = ({
    menuItems,
    onSelectMenu,
    onClickMenu,
    className,
}: KebabMenuProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement | null>(null);

    const onSelect = useCallback((elem: React.MouseEvent<HTMLDivElement>, item: IKebabItem) => {
        elem.stopPropagation();

        if (typeof onSelectMenu === 'function') {
            onSelectMenu(item);
        }

        setIsOpen(false);
    }, [onSelectMenu]);

    const onClick = useCallback(() => {
        setIsOpen(!isOpen);
        onClickMenu && onClickMenu(!isOpen);
    }, [isOpen, onClickMenu]);

    const onClickOutside = useCallback((elem) => {
        const dataName = elem.target?.getAttribute('data-name');

        const isNotMenuRow = !(dataName && (dataName === 'menu-row'));

        if (isNotMenuRow && (elem.target !== menuRef?.current)) {
            setIsOpen(false);
        }
    }, []);

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('pointerdown', onClickOutside, true);
        }
        return () => document.removeEventListener('pointerdown', onClickOutside, true);
    }, [onClickOutside, isOpen]);

    return (
        <ST.KebabMenu ref={menuRef} data-name='kebab-menu' data-test='kebab-menu' onClick={onClick} className={className}>
            {isOpen &&
                <ST.MenuPopup data-name='popup-menu'>
                    {menuItems.map((item, index) => {
                        return (
                            <ST.MenuRow
                                key={item.value}
                                data-id={index}
                                data-name='menu-row'
                                onClick={(elem: React.MouseEvent<HTMLDivElement>) => onSelect(elem, item)}
                            >
                                {item.label}
                            </ST.MenuRow>
                        );
                    })}
                </ST.MenuPopup>
            }
        </ST.KebabMenu>
    );
};
